import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M12.75 8.255v7.5m6-7.5h-3v3.75m0 0v3.75m0-3.75H18M9.75 9.353c-1.03-1.464-2.698-1.464-3.728 0-1.03 1.465-1.03 3.839 0 5.303 1.03 1.465 2.699 1.465 3.728 0v-2.651h-1.5m-3.75 7.5h15a2.25 2.25 0 0 0 2.25-2.25v-10.5a2.25 2.25 0 0 0-2.25-2.25h-15a2.25 2.25 0 0 0-2.25 2.25v10.5a2.25 2.25 0 0 0 2.25 2.25"
    }, null, -1)
  ])))
}
export default { render: render }